export interface Configurations {
  clientId: string;
  clientSecret: string;
  fireBase: IFireConfig;
}

export interface IFireConfig {
  apiKey: string;
}

export interface GoogleConfigurations {
  googleKey: string;
  googleApiLink: string;
}

export enum EGoogleLib {
  places = 'places',
  geometry = 'geometry',
  marker = 'marker',
  maps = 'maps',
}

export interface CustomTokenDTO {
  customToken: CustomToken;
}

export interface CustomToken {
  result: string;
  id: number;
  exception: null;
  status: number;
  isCanceled: boolean;
  isCompleted: boolean;
  isCompletedSuccessfully: boolean;
  creationOptions: number;
  asyncState: null;
  isFaulted: boolean;
}
